var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('uw-input',_vm._b({attrs:{"type":"text","prefix":"€","no-validate":""},on:{"change":_vm.onChange},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},'uw-input',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }